import { render, staticRenderFns } from "./gszl.vue?vue&type=template&id=31daf066"
import script from "./gszl.vue?vue&type=script&lang=js"
export * from "./gszl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports